/*
 * Hero parallax.
 *
 * The template already moves the hero photograph and copy on scroll via its own
 * inline scripts (--nr-hero-bg, --nr-hero-copy-y, --nr-hero-opacity). What it never
 * drove is .nrhero:after: the glyph column reads --nr-symbol-y and nothing in the
 * theme ever set it, so that layer sat still.
 *
 * This owns only the layers nothing else touches, so the two systems do not fight
 * over the same custom properties on every scroll event:
 *   gold glow (:before)   -> slow drift
 *   glyph column (:after) -> fastest, and counter to the rest
 */
(() => {
  const hero = document.querySelector('.namaref .nrhero');
  if (!hero || hero.dataset.nsParallax) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  hero.dataset.nsParallax = 'true';

  let ticking = false;

  const clear = () => {
    hero.style.removeProperty('--nr-parallax');
    hero.style.removeProperty('--nr-symbol-y');
  };

  const frame = () => {
    ticking = false;
    if (reduced.matches) return;

    const rect = hero.getBoundingClientRect();
    // Measured from scroll position, not from -rect.top. The hero sits ~89px down the
    // document, so the previous formula stayed pinned at 0 until you had scrolled past
    // its top edge — the layers were mathematically motionless on arrival.
    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    const progress = Math.min(1, Math.max(0, scrollTop / Math.max(rect.height * 0.8, 1)));

    // Narrow screens get a smaller throw: the hero is proportionally taller there,
    // so the same pixel amounts read as a much larger movement.
    const scale = window.innerWidth < 750 ? 0.55 : 1;

    // --nr-hero-bg and --nr-hero-copy-* are already driven by the template's own
    // scroll scripts. Writing them here too made two handlers fight over the same
    // property every scroll event, so this owns only what nothing else sets.
    hero.style.setProperty('--nr-parallax', (progress * 26 * scale).toFixed(1) + 'px');
    hero.style.setProperty('--nr-symbol-y', (progress * -54 * scale).toFixed(1) + 'px');
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  const onPreferenceChange = () => (reduced.matches ? clear() : onScroll());
  reduced.addEventListener ? reduced.addEventListener('change', onPreferenceChange)
                           : reduced.addListener(onPreferenceChange);

  onScroll();
})();
